<template>
  <q-drawer
    :width="265"
    show-if-above
    v-model="this.model"
    side="left"
    class="menu navbarMenu"
  >
    <q-linear-progress v-if="this.loading" indeterminate />
    <div class="menu__header">
      <q-toolbar-title class="menu__logo">
        <img src="@/assets/img/logo.png" alt="menu_logo" />
        <q-btn
          dense
          flat
          round
          class="menu__logo_toggle"
          color="#fff"
          icon="menu"
          @click.prevent="$emit('toggle-navbar')"
        />
      </q-toolbar-title>
    </div>
    <div style="padding: 15px 8px;">
      <CityBlock />
      <menu-list :menu="menu" />
    </div>
  </q-drawer>
</template>
<script>
import MenuList from './MenuList'
import {getMenuData} from "@/components/layout/Navbar/services";
import CityBlock from '@/components/features/cityBlock'

export default {
  props: ["value"],
  name: "Navbar",
  components: {MenuList, CityBlock},
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("change", newValue);
      },
    },
  },
  async mounted() {
    this.loading = true
    this.menu = await getMenuData()
    this.loading = false
  },
  data() {
    return {
      menu: [],
      loading: false
    };
  },
};
</script>

<style lang="scss">
.navbarMenu {
  scrollbar-width: none;
  margin: 0; box-shadow: none; border-radius: 16px;

  @media (max-width: 991px) {
    border-radius: unset;
  }

  scrollbar-width: none;
  &::-webkit-scrollbar-button {
    display: none;
    width: 0;
    height: 0;
  }
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
}
</style>
<style scoped lang="scss">
@use "@/assets/styles/quasar.variables.scss" as *;

.menu {
  &__list {
    padding: 0;
  }

  &__flex {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 10px;
    padding: 0 10px 5px;
    margin-top: 10px;
  }

  &__logo {
    display: none;
    align-items: center;

    & > img {
      height: 35px;
    }

    &_toggle {
      color: #fff;
    }
  }
}

@media (max-width: 576px) {
  .menu {
    &__header {
      display: flex;
      flex-direction: column;
      gap: 10px;
      background-color: $primary;
    }

    &__logo {
      display: flex;
      justify-content: space-between;
      padding: 10px !important;

      & > img {
        display: block;
        height: 24px;
      }
    }
  }
}
</style>
